import {APIHOST} from "@/settings";
import SessionStorage from "sessionstorage";
import axios from "axios";

class ContractionService {
    sync(contractions) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.post(`${APIHOST}/api/SyncContractionDirectory`, {
            Contractions: contractions
        }, {
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }

    getAll({sortBy, sortDesc, skip, limit, search}) {
        const oAuthAccess = JSON.parse(SessionStorage.getItem('auth_token'));

        return axios.get(`${APIHOST}/api/ContractionDirectory`, {
            params: {
                sortBy: sortBy,
                desc: sortDesc,
                skip: skip,
                limit: limit,
                q: search
            },
            headers: {
                'Authorization': `Bearer ${oAuthAccess.access_token}`
            }
        });
    }
}

export default new ContractionService();